import { WIN_EVENT_DELAY } from '../../constants';
import { GameStage } from '../../model/enumeration/GameStage.enum';
import { WPlayer } from '../../model/websocket/WPlayer';
import gameStore from '../../store/GameStore';
import playerStore from '../../store/PlayerStore';
import { WEvent } from './WEvent';

export class WGameFinishEvent extends WEvent {
  gameId: string;
  stage: GameStage;
  players: WPlayer[];
  boardNumber: number;

  constructor(event: WGameFinishEvent) {
    super(event.tableId, event.eventType, event.eventTime);
    Object.assign(this, event);
  }

  public applyWebsocketChanges = (): Promise<void> => {
    if (this.boardNumber === 2 || this.boardNumber === 3) {
      const delay = WIN_EVENT_DELAY * (this.boardNumber === 3 ? 2 : 1);
      return new Promise(resolve =>
        setTimeout(() => {
          this.executeChanges().then(resolve);
        }, delay),
      );
    } else {
      return this.executeChanges();
    }
  };

  private executeChanges = (): Promise<void> => {
    return gameStore.findActiveGame(this.tableId).then(game => {
      if (this.boardNumber === 1) {
        game.setStage(this.stage);
      }
      game.setShownWinBoard(this.boardNumber);
      game.setPlayers(
        playerStore.modifyPlayerList(
          this.players,
          game.players,
          (source, target) => {
            target.totalBet = 0;
            target.stack = source.stack;
            target.won = source.won;
            target.lost = source.lost;
            target.rake = source.rake;
            target.cards = source.cards;
            target.country = source.country;
          },
        ),
      );
      game.resetActivePlayer();
    });
  };
}
